import Box from '../../../components/Box/Box';
import Link from '../../../components/Link/Link';

function ErrorPageSide(): JSX.Element {
  return (
    <div className='error-page__side'>
      <Box bgColor='lilac'>
        <>
          <h2>Does this help instead?</h2>
          <p>
            <b>Try one of the following options:</b>
          </p>
          <ul className='error-page__links'>
            <li>
              <Link
                href='https://www.newcastlepermanent.com.au/contact-us'
                displayBlock={true}
              >
                Get in touch
              </Link>
            </li>
            <li>
              <Link
                href='https://www.newcastlepermanent.com.au/forms/enquiry/general'
                displayBlock={true}
              >
                Make an enquiry
              </Link>
            </li>
            <li>
              <Link
                href='https://www.newcastlepermanent.com.au/locate-us'
                displayBlock={true}
              >
                Find a local branch
              </Link>
            </li>
          </ul>
        </>
      </Box>
    </div>
  );
}

export default ErrorPageSide;
